<div
	class="w-100 fl fl-dir-c fl-gap-0h fl-jc-c p-3-rl fl-adaptable"
	style="padding-bottom: calc(var(--spacing) * 7)"
>
	<div class="fl fl-dir-c fl-gap-3 fl-jc-c h-100">
		<div class="fc-warn">
			<ng-content select="[image]"></ng-content>
		</div>
		<div class="fw-bold fs-h1">
			<ng-content select="[title]"></ng-content>
		</div>
		<div class="fs-body1">
			<ng-content></ng-content>
		</div>
	</div>
</div>
<div class="fl fl-dir-r fl-gap-1 pos-sticky w-100 p-3-rbl fl-ai-fe options p-1-t" style="bottom: 0">
	<ng-container [ngTemplateOutlet]="options"></ng-container>
</div>
<ng-template #options>
	<ng-content select="[options]"></ng-content>
</ng-template>
